import React from 'react';
import cx from 'classnames';

import { InfoIcon } from '@motorway/mw-highway-code';

import styles from './NotificationBanner.scss';

type LabelSizeType = 'default' | 'large';
type MessageType = [string] | React.ReactNode;

export type NotificationBannerProps = {
  className?: string;
  icon?: React.ReactNode;
  label?: string | [string] | null;
  labelSize?: LabelSizeType;
  message: MessageType;
  variant?: 'info' | 'error';
}

export const NotificationBanner = ({
  className, icon, label, labelSize = 'default', message, variant = 'info',
}: NotificationBannerProps) => (
  <article className={cx(styles.notification, className, styles[variant])}>
    {icon || <InfoIcon />}
    {label && (
      <p className={cx(styles.label, styles[labelSize])}>
        {label}
      </p>
    )}
    <p className={styles.message}>{message}</p>
  </article>
);
